
<template>
  <div class="col-md-12" style="height: 100vh;display: flex;justify-content: center;align-items: center;" v-if="isLoadShow">
    <b-spinner style="width: 10em; height: 10rem;" label="Large Spinner" type="grow"></b-spinner>
  </div>
</template>
<script>
export default {
  name: 'LoadingContentPanel',
  props: {
    isLoadShow: Boolean
  },
  methods: {
  }
}
</script>
